import { gql } from "@apollo/client";

export const FETCH_REPORT_LIST = gql`
  query fetchReportList(
    $providerId: ID!
    $page: Int!
    $pageSize: Int!
    $type: String!
    $search: String
  ) {
    fetchReportList(
      providerId: $providerId
      page: $page
      pageSize: $pageSize
      type: $type
      search: $search
    ) {
      totalCount
      reports {
        _id
        orderId
        status
        purchaseDate
        reportDate
        clientName
      }
    }
  }
`;

export const FETCH_REPORT_DETAILS = gql`
  query fetchReportDetails($reportId: String!) {
    fetchReportDetails(reportId: $reportId) {
      success
      message
      report {
        _id
        orderId
        productSubscriptionId
        orderType
        reportSummary {
          description
          medias {
            key
            uri
            uri_thumbnail
            width
            height
            mediaType
          }
        }
        userInfo {
          userName
          email
          phone
        }
        reportDetails {
          status
          reportedOn
          replyBy
          orderId
          purchaseDate
          serviceMethod
          scheduleDate
        }
      }
    }
  }
`;
